<script setup>
import AppStatus from '@/components/AppStatus.vue'
</script>

<template>
    <div class="w-screen h-full flex justify-content-center">
        <div style="max-width: 800px" class="w-full">
            <div class="relative">
                <div>
                    <a href="https://giep.nc/poles/spot/" class="block" rel="noreferrer noopener" target="_blank">
                        <img src="/img/printable-header.png" class="max-w-full w-auto h-auto block">
                    </a>
                </div>
                <div class="text-white absolute top-0 right-0 h-full flex flex-column justify-content-center mr-2 text-xs text-right no-print">
                    <AppStatus />
                </div>
            </div>
            <slot/>
        </div>
    </div>
</template>
<style lang="scss" scoped>
</style>
